module.exports = __webpack_public_path__ + "static/media/loadingLogo.b46b3823.svg";